import _ from 'lodash';
import Immutable from 'seamless-immutable';

/**
 * Adobe Source Model
 * @typedef {Object} AdobeAttribute
 * @property {string[]} attributeCode        -- an identifier to be used in to connect the selected option value if present
 * @property {string[]} defaultFrontendLabel -- the value to be presented for the user in a dropdown
 * @property {string[]} frontendInput        -- an enum of values, however we are only interested in 'multiselect' and 'select' as those 2 will enforce the question answers data values
 * @property {string[]} backendType          -- a unique value, manually set by the BE and required for their process to work with the display data when submitted
 * @property {array[]} frontendLabels        -- currently not a used value
 * @property {array[{
 *  @@property {string[]} value -- a string that represents the value to be mapped for the data value field for a question option
 *  @@property {string[]} label -- the human readable value that will be displayed in the dropdown menu for question answers
 * }]} options -- a label and value pair for the dropdown inside the question answers

/**
 * Create a Adobe Attribute Model from provided data
 */
function create(dropdownItem = {}) {
  const result = _.clone(dropdownItem);

  //it is easier to track for values if the options are defined
  //as either a parsed array of single-select options, or as undefined
  if (_.isEmpty(result.options)) result.options = undefined;
  else result.options = result.options.map((option) => ({ text: option.label, value: String(option.value) }));

  //for convenience to make the dropdown easier to work with values
  result.value = result.attributeCode;
  result.text = result.defaultFrontendLabel;
  delete result.attributeCode;
  delete result.defaultFrontendLabel;

  return Immutable(result);
}

/**
 * Transforms a backend adobe attribute object into a frontend AdobeAttributeModel
 * @param {Object} dropdownItem - backend formatted adobe attribute value
 * @returns {AdobeAttribute}
 */
function deserialize(dropdownItem) {
  const result = _.pick(dropdownItem, _keys);
  return create(result);
}

const _keys = [
  'attributeCode',
  'defaultFrontendLabel',
  'frontendInput',
  'frontendLabels', //not in use
  'options',
  'backendType',
];

export default {
  create,
  deserialize,
};
